import { render, staticRenderFns } from "./SystemModulesForm.vue?vue&type=template&id=3c00235e"
import script from "./SystemModulesForm.vue?vue&type=script&lang=js"
export * from "./SystemModulesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports